import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlogPost } from 'avn/interfaces/homepage';
import { IfcObject } from 'avn/modules/home/health-hub/health-hub.component';
import { ApiService } from 'avn/services/api.service';

@Component({
  selector: 'app-category-related-blogs',
  templateUrl: './category-related-blogs.component.html',
  styleUrls: ['./category-related-blogs.component.scss']
})
export class CategoryRelatedBlogsComponent implements OnInit {
  category = '';
  blogData: BlogPost[] = [];
  categoryIds: IfcObject = {};
  authorIds: IfcObject = {};

  constructor(
    private route: ActivatedRoute,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      this.category = params.category_name;
      this.fetchBlogData();
    });
  }

  fetchBlogData() {
    this.api.getFeaturedPosts(this.category).subscribe({
      next: (response) => {
        this.blogData = response;
        this.fetchCategoryById();
      }
    });
  }

  fetchCategoryById() {
    for (let i = 0; i < this.blogData.length; i++) {
      const category = this.blogData[i].categories[0];

      this.api.getCategoryById(category).subscribe((response) => {
        this.categoryIds[response.id] = response.name;
      });
    }
  }

  fetchAuthorById() {
    for (let i = 0; i < this.blogData.length; i++) {
      const id = this.blogData[i].author;

      this.api.fetchAuthorById(id).subscribe((response) => {
        this.authorIds[response.id] = response.name;
      });
    }
  }

  fetchCategory(id: number) {
    return this.categoryIds[id] || '';
  }
}
